import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/site';
import FaqAccordion from '@/components/feature/FaqAccordion';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { useSeo } from '@/hooks/useSeo';

export default function Faq() {
  useSeo({
    title: '常见问题 - 策驰漫画网，追更进度与汉化进度解答',
    description:
      '策驰漫画网常见问题：如何查看同步更新进度与汉化进度、什么是抢先看、如何接收更新提醒等，帮你顺利追更。',
    keywords: '策驰漫画网,常见问题,追更进度,汉化进度,抢先看,更新提醒',
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <div className="mx-auto max-w-4xl px-4 pb-20 pt-28 md:px-6 md:pt-32">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />

      <div className="mt-4">
        <h1 className="font-heading text-2xl text-foreground-950 md:text-4xl">常见问题</h1>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
          关于抢先看、同步更新进度与汉化进度的常见疑问，这里都有答案。
        </p>
      </div>

      <div className="mt-8">
        <FaqAccordion />
      </div>

      <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-6 text-center">
        <h2 className="text-base font-bold text-foreground-950">没有找到你的问题？</h2>
        <p className="mt-2 text-sm text-foreground-600">欢迎前往关于我们页面留言，我们会尽快为你解答。</p>
        <Link
          to="/about"
          className="mt-4 inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
        >
          前往联系我们 <i className="ri-arrow-right-line ml-1.5"></i>
        </Link>
      </div>
    </div>
  );
}